module.exports = __webpack_public_path__ + "static/assets/135e085e78969522fe44f31bc02db975.png";